import { render } from "./MSelect.vue?vue&type=template&id=51581444&scoped=true"
import script from "./MSelect.vue?vue&type=script&lang=js"
export * from "./MSelect.vue?vue&type=script&lang=js"

import "./MSelect.vue?vue&type=style&index=0&id=51581444&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51581444"]])

export default __exports__